import { withInstall } from '../../utils/vue-utils'
import _Timeline from './src/timeline'

export const Timeline = withInstall(_Timeline)
export type TimelineInstance = InstanceType<typeof _Timeline>
export default Timeline
